/**
 * Resolve the effective, live-visible title for a STATIC portfolio project.
 *
 * Portfolio.jsx (line ~493) and Admin.jsx both need the same 3-layer precedence:
 *   1. static_overrides[index].title   — new admin UI edits (highest priority)
 *   2. title_overrides[index]          — legacy /api/titles entries (what the
 *                                        live page has been showing since
 *                                        before static_overrides existed)
 *   3. project.title                   — source-code baseline (lowest)
 *
 * Consolidating the chain here prevents drift between the two files. If the
 * priority ever changes, ONLY this helper needs updating.
 *
 * @param {number|string} index         Numeric project index (0-based).
 * @param {object} staticOverrides      Map keyed by string index → override
 *                                      object with optional `.title`.
 * @param {object} titleOverrides       Map keyed by string index → string title.
 * @param {object} project              Source-code project ({title, ...}).
 * @returns {string}                    The effective title (never blank).
 */
export const resolveStaticTitle = (index, staticOverrides, titleOverrides, project) => {
  const key = String(index);
  const ov = (staticOverrides && staticOverrides[key]) || null;
  const staticOverrideTitle = (ov && typeof ov.title === "string" ? ov.title : "").trim();
  if (staticOverrideTitle) return staticOverrideTitle;
  const legacy = (titleOverrides && titleOverrides[key]) || "";
  if (legacy) return legacy;
  return (project && project.title) || "";
};

/**
 * Just the legacy-vs-source portion of the chain — useful for Admin.jsx's
 * `defaults.legacy_title` lookup where the static-override layer is handled
 * separately (as the editable field).
 */
export const resolveLegacyTitle = (index, titleOverrides) => {
  const key = String(index);
  return (titleOverrides && titleOverrides[key]) || "";
};
